import { createApp } from 'vue';
import App from './App.vue';
import './assets/j-calculator.scss';

createApp(App).mount('#app')
